import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    requestClientUsers,
    requestImpersonate,
    requestSearchClientUsers,
    requestStopImpersonating,
} from '../support/support';
import { RequestImpersonate } from '../support/types/Support';

export function useClientUsers(clientIdOrSearch: string | undefined) {
    return useQuery({
        queryKey: [`clientUsers-${clientIdOrSearch}`],
        enabled: false,
        queryFn: async ({ signal }) => (await requestClientUsers(clientIdOrSearch, signal)).data,
    });
}

export function useSearchClientUsers(search: string) {
    return useQuery({
        queryKey: [`searchClientUsers-${search}`],
        enabled: false,
        queryFn: async ({ signal }) => (await requestSearchClientUsers(search, signal)).data,
    });
}

export const useImpersonate = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: RequestImpersonate) => (await requestImpersonate(data)).data,
        onSuccess: async () => {
            queryClient.resetQueries();
        },
    });
};

export const useStopImpersonating = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => (await requestStopImpersonating()).data,
        onSuccess: async () => {
            queryClient.resetQueries();
        },
    });
};
